import React, { useState, useRef, useEffect } from "react";
import { countryCodes } from "../../utils/constants.js";
import { Container, Input } from "../styled.ts";
import { Typography } from "../typography/index.tsx";
import { useMobile } from "../../hooks/isMobile.tsx";

const DropDown = ({ onSelect, countryCode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [code, setCode] = useState("");
  const ref = useRef(null);
  const { isMobile } = useMobile();

  const filteredCodes = countryCodes.filter(({ value }) =>
    value.startsWith(code) || value.startsWith(`+${code}`)
  );

  useEffect(() => {
    if (!isOpen) return;
    ref.current.focus();
    window.scrollBy(0, ref.current.getBoundingClientRect().top - 100);
  }, [isOpen]);
  return (
    <Container
      width="100px"
      justifyContent="center"
      style={{ position: "relative" }}
      onBlur={(e) => {
        if (e.currentTarget.contains(e.relatedTarget)) return;
        setIsOpen(false);
        console.log("dfkgnj");
      }}
    >
      <Container
        onClick={() => {
          setIsOpen(true);
          setCode("");
        }}
        style={{ cursor: "pointer" }}
        justifyContent="center"
        alignItems="center"
        gap="5px"
      >
        {!isOpen ? (
          <>
            <Typography color="#fff">{countryCode} </Typography>
            <img color="#fff" width={"20px"} src="/down-arrow.png"></img>
          </>
        ) : (
          <Input
            ref={ref}
            onChange={(e) => {
              setCode(e.target.value);
            }}
            type={isMobile ? "number" : "text"}
            placeholder="+[code]"
            width="70%"
            textAlign="center"
            tabIndex={"0"}
          />
        )}
      </Container>
      {isOpen && (
        <Container
          style={{
            position: "absolute",
            top: "calc( 100% + 20px)",
            left: "0",
            overflowY: "auto",
            maxHeight: "200px",
          }}
          width="100px"
          radius="10px"
          column
          padding="10px"
          gap="10px"
          background="#fff"
          onClick={(e) => {
            setIsOpen(false);
            onSelect(e.target.getAttribute("value"));
          }}
        >
          {filteredCodes.map(({ label, value }) => (
            <Container
              key={label}
              value={value}
              hover
              style={{ cursor: "pointer" }}
              tabIndex={"0"}
            >
              {label}
            </Container>
          ))}
        </Container>
      )}
    </Container>
  );
};

export default DropDown;
